import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { FormsModule } from '@angular/forms';
import { HttpClientModule, HTTP_INTERCEPTORS } from '@angular/common/http';
import { BrdsModule } from '../brds/brds.module';
import { BsDropdownModule } from 'ngx-bootstrap';
import { McNumberPipe } from './mc-number.pipe';
import { ApiService } from './api/api.service';
import { UiModule } from './ui/ui.module';
import { AuthInterceptor } from '../core/security/interceptors/auth-interceptor.service';
import { GuardsModule } from './guards/guards.module';
import { SecuritySharedModule } from '../core/security/security-shared.module';

import { PerfectScrollbarModule } from 'ngx-perfect-scrollbar';

@NgModule({
  imports: [
    CommonModule,
    FormsModule,
    SecuritySharedModule,
    BrdsModule,
    GuardsModule,
    UiModule,
    HttpClientModule,
    BsDropdownModule.forRoot(),
    PerfectScrollbarModule
  ],

  exports: [
    CommonModule,
    FormsModule,
    BrdsModule,
    GuardsModule,
    UiModule,
    BsDropdownModule,
    SecuritySharedModule,
    McNumberPipe,
    PerfectScrollbarModule
  ],
  declarations: [
    McNumberPipe
  ],
  providers: [
    { provide: HTTP_INTERCEPTORS, useClass: AuthInterceptor, multi: true },
    ApiService
  ]
})
export class SharedModule { }



// WEBPACK FOOTER //
// /home/runner/work/cdg-missioncontrol/cdg-missioncontrol/MissionControlClient2/MissionControl.WebUi2/mc-app/src/app/shared/shared.module.ts